export const getEventSummary = (timeevent) => {
  if (!timeevent) {
    return '';
  }

  const customFields = Array.isArray(timeevent.customFields) ? timeevent.customFields : [];
  const summaryField = customFields.find(
    (field) => typeof field?.variable === 'string'
      && field.variable.trim().toLowerCase() === 'eventsummary'
  );

  if (!summaryField) {
    return '';
  }

  return summaryField.reply || '';
};
